var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 166,
    viewBox: "0 0 255 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M128.091 165.373C197.673 165.373 254.08 129.362 254.08 84.941C254.08 40.5197 197.673 4.50903 128.091 4.50903C58.5095 4.50903 2.10254 40.5197 2.10254 84.941C2.10254 129.362 58.5095 165.373 128.091 165.373Z",
    fill: "url(#paint0_radial_107_46987)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7181 101.073H222.141C223.741 97.3562 224.625 93.2585 224.625 88.9627C224.625 71.9775 210.85 58.1914 193.844 58.1914C187.383 58.1914 181.394 60.1869 176.442 63.5839C177.112 61.9235 177.493 60.0955 177.493 58.1914C177.493 50.2243 171.032 43.7654 163.063 43.7654C163.032 43.7654 163.002 43.7654 162.956 43.7654C161.722 27.8923 148.465 15.4009 132.282 15.4009C126.278 15.4009 120.686 17.1223 115.947 20.0928C111.604 8.3631 100.312 0 87.0705 0C70.08 0 56.2895 13.771 56.2895 30.7714C56.2895 31.1065 56.3047 31.4264 56.32 31.7463C56.3047 31.7463 56.3048 31.7463 56.2895 31.7463C48.32 31.7463 41.8591 38.2052 41.8591 46.1723C41.8591 46.8882 41.92 47.6042 42.0114 48.2897C38.5371 46.9187 34.7429 46.1723 30.7809 46.1723C13.7905 46.1723 0 59.9432 0 76.9436C0.0152381 86.7234 4.58667 95.4368 11.7181 101.073Z",
    fill: "url(#paint1_linear_107_46987)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.351 71.612C168.381 71.5968 168.412 71.5815 168.442 71.5815C168.427 71.612 168.396 71.6425 168.381 71.6729L168.351 71.612Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_107_46987",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.09 84.9427) scale(125.983 80.434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#338388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0393,
    stopColor: "#34777A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2401,
    stopColor: "#4C6F71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#8F9D9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6084,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7675,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9034,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_46987",
    x1: 56.5,
    y1: -22.5,
    x2: 225,
    y2: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9FFE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9FFE5",
    stopOpacity: 0.56
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.992dd0adbe6d9721e18765e1d2bb0615.svg";
export { ForwardRef as ReactComponent };